var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92857 23.9925C10.8983 14.9146 19.9583 8.57129 30.5 8.57129C41.0417 8.57129 50.1017 14.9147 54.0714 23.9925V8.57134L58.3571 8.57134V30.5733C59.6381 31.3143 60.5 32.6993 60.5 34.2856V38.5713C60.5 40.9383 58.5812 42.8571 56.2143 42.8571L56.2143 51.4284H4.78571L4.78571 42.8571C2.41878 42.8571 0.5 40.9383 0.5 38.5713V34.2856C0.5 32.6993 1.36185 31.3143 2.64286 30.5733L2.64286 8.57134L6.92857 8.57134L6.92857 23.9925ZM13.3571 32.1427C13.3571 28.5923 16.2353 25.7141 19.7857 25.7141H41.2143C44.7647 25.7141 47.6428 28.5923 47.6428 32.1427C47.6428 35.6931 44.7647 38.5713 41.2143 38.5713H19.7857C16.2353 38.5713 13.3571 35.6931 13.3571 32.1427ZM24.0714 34.2856C25.2549 34.2856 26.2143 33.3262 26.2143 32.1427C26.2143 30.9593 25.2549 29.9999 24.0714 29.9999C22.888 29.9999 21.9286 30.9593 21.9286 32.1427C21.9286 33.3262 22.888 34.2856 24.0714 34.2856ZM39.0714 32.1427C39.0714 33.3262 38.112 34.2856 36.9286 34.2856C35.7451 34.2856 34.7857 33.3262 34.7857 32.1427C34.7857 30.9593 35.7451 29.9999 36.9286 29.9999C38.112 29.9999 39.0714 30.9593 39.0714 32.1427Z",
    fill: "#909090"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClass);
export default __webpack_public_path__ + "static/media/icon-class.af1d6f0b.svg";
export { ForwardRef as ReactComponent };